<template>
  <div v-if="object" :class="{ [$style.deleteIndent]: this.$store.state.deleteIndent }">
    <div :class="[$style.wrapper, !isOpen ? $style.hide : null]">
      <div :class="$style.photo">
        <swiper
          ref="swiper"
          :slidesPerView="1"
          :spaceBetween="10"
          :pagination="paginationParams"
          :autoplay="autoplayParams"
          class="swiper"
          @swiper="onSwiper"
        >
          <swiper-slide v-for="(photo, index) in photos" :key="index">
            <img :src="photo" alt="Фото" class="swiper-image" />
          </swiper-slide>
          <div v-if="this.photos.length > 1" class="custom-pagination">
            <div
              v-for="(photo, index) in photos"
              :key="index"
              class="pagination-dot"
              :class="{ active: currentSlide === index }"
              @click="goToSlide(index)"
            ></div>
          </div>
        </swiper>
      </div>

      <div :class="$style.content">
        <div :class="$style.title">
          <p :class="$style.name">{{ this.object.header }}</p>
          <p :class="$style.tag">Tag: {{ this.object.id }}</p>
        </div>
        <p :class="$style.price">{{ this.object.price }} руб.</p>

        <p :class="$style.description" v-html="object.description"></p>

        <div v-if="object.super_additions" :class="$style.superAddition">
          <img src="@/assets/img/fire.svg" alt="" />
          <p>{{ this.object.super_additions }}</p>
        </div>

        <div :class="$style.additions">
          <p v-if="object.additions_one" :class="$style.addition">{{ object.additions_one }}</p>
          <p v-if="object.additions_two" :class="$style.addition">{{ object.additions_two }}</p>
          <p v-if="object.additions_three" :class="$style.addition">{{ object.additions_three }}</p>
          <p v-if="object.additions_four" :class="$style.addition">{{ object.additions_four }}</p>
        </div>

        <div v-if="object.address" :class="$style.address">
          <img src="@/assets/img/address-primary-color.svg" alt="" />
          <p>{{ object.address }}</p>
        </div>

        <div :class="$style.buttons">
          <button
            v-if="isTelegram"
            @click="copyTelegramText"
            :class="[$style.button_transparent, linkCopied ? $style.buttonCopied : '']"
          >
            <img :class="$style.img" src="../assets/img/copy.svg" alt="" />
            {{ linkCopied ? 'Ссылка скопирована' : 'Скопировать ссылку' }}
          </button>

          <button @click="openSendBid" :class="$style.button">
            <img :class="$style.img" src="../assets/img/send.svg" alt="" />Отправить заявку
          </button>
        </div>
      </div>
      <p :class="$style.connection">Связаться с нами:</p>
      <div :class="$style.contacts">
        <button
          @click="copyPhoneNumber"
          :class="[$style.contact_button, phoneCopied ? $style.contactCopied : '']"
        >
          <img src="../assets/img/tel.svg" alt="Телефон" />
          {{ phoneCopied ? 'Номер скопирован' : 'Копировать номер' }}
        </button>

        <a :href="'https://wa.me/79263661518'" target="_blank">
          <button :class="$style.contact">
            <img src="../assets/img/whatsapp.svg" alt="WhatsApp" />
          </button>
        </a>
        <a :href="'https://t.me/SkolkovoRealtyhelper_bot'" target="_blank">
          <button :class="$style.contact">
            <img src="../assets/img/telegram.svg" alt="Telegram" />
          </button>
        </a>
      </div>
    </div>

    <SendBid v-if="sendBidOpen" :object="object" :link="link" @backToOpenCard="closeSendBid" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SendBid from './SendBid.vue';

export default {
  components: { Swiper, SwiperSlide, SendBid },
  data() {
    return {
      object: null,
      isOpen: true,
      sendBidOpen: false,
      phoneNumber: '+74957409988',
      isTelegram: false,
      photos: [],
      paginationParams: {
        clickable: true,
        type: 'bullets',
        dynamicBullets: true,
        renderBullet: (index, className) => {
          return `<span class="${className} custom-bullet"></span>`;
        },
      },
      autoplayParams: {
        delay: 3000,
        disableOnInteraction: false,
      },
      swiperInstance: null,
      currentSlide: 0,
      linkCopied: false,
      phoneCopied: false,
      link: '',
    };
  },
  async mounted() {
    window.Telegram.WebApp.BackButton.show();
    window.Telegram.WebApp.BackButton.onClick(() => {
      this.isOpen = false;
      window.Telegram.WebApp.BackButton.hide();
      setTimeout(() => {
        window.history.pushState({}, '', '/');
        this.$emit('deleteSelectedObject');
      }, 250);
    });

    const objectId = window.location.pathname.split('/').pop();

    try {
      const response = await fetch(`${window.location.origin}/api/object/${objectId}`);
      if (response.ok) {
        this.object = await response.json();
        this.photos = this.object.photo_urls || [];
      } else {
        alert('Объект не найден');
      }
    } catch (error) {
      alert('Ошибка при получении объекта:', error);
    }

    this.link = `https://t.me/@SkolkovoRealtyBot?startapp=opencard_${this.object.id}`;

    if (window.Telegram && window.Telegram.WebApp) {
      this.isTelegram = true;
      this.initTelegramButton();
    }
  },
  computed: {
    formattedPrice() {
      if (this.object.price) {
        return new Intl.NumberFormat('ru-RU').format(this.object.price) + ' руб.';
      }
      return '';
    },
  },
  methods: {
    openSendBid() {
      this.sendBidOpen = true;
    },
    closeSendBid() {
      this.sendBidOpen = false;
    },
    async copyTelegramText() {
      if (this.isTelegram && window.Telegram && window.Telegram.WebApp) {
        try {
          const telegramLink = `https://t.me/@SkolkovoRealtyBot?startapp=opencard_${this.object.id}`;
          await navigator.clipboard.writeText(telegramLink);
          this.linkCopied = true;
          setTimeout(() => (this.linkCopied = false), 2000);
        } catch (error) {
          console.error('Copy failed:', error);
        }
      }
    },
    async copyPhoneNumber() {
      if (this.isTelegram && window.Telegram && window.Telegram.WebApp) {
        await navigator.clipboard.writeText(this.phoneNumber);
        this.phoneCopied = true;
      }
    },
    initTelegramButton() {
      window.Telegram.WebApp.MainButton.setText('Копировать номер');
      window.Telegram.WebApp.onEvent('mainButtonClicked', this.copyPhoneNumber);
    },
    onSwiper(swiper) {
      this.swiperInstance = swiper;
      swiper.on('slideChange', () => {
        this.currentSlide = swiper.activeIndex;
      });
    },
    goToSlide(index) {
      if (this.swiperInstance) {
        this.swiperInstance.slideTo(index);
      }
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}
@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
.wrapper {
  position: absolute;
  background: $background;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation: show 0.25s ease;
  &.hide {
    animation: hide 0.25s ease;
  }
}
.photo {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 345px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 116px 0 0 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.back {
  position: fixed;
  z-index: 2;
  top: 16px;
  left: 16px;
  width: 39px;
  height: 39px;
}
.content {
  padding: 24px;
}
.title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.name {
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.5px;
  color: $primary;
}
.tag {
  font-weight: 400;
  font-size: 12px;
  line-height: 22px;
  color: rgba(202, 201, 198, 0.25);
}
.price {
  font-weight: 800;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0.5px;
  color: #f7f7f7;
  margin-bottom: 10px;
}
.description {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: start;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  color: #f7f7f7;
  margin-bottom: 40px;
}
.superAddition {
  background-color: $primary;
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 14px;
  width: fit-content;
  img {
    margin-right: 8px;
  }
}
.additions {
  display: flex;
  flex-wrap: wrap;
  .addition {
    color: $white;
    text-wrap: nowrap;
    border-radius: 8px;
    font-size: 14px;
    margin: 8px 8px 0 0;
    padding: 6px 8px;
    background-color: $bg-dark;
  }
}
.address {
  margin: 24px 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: $white;
  img {
    margin-right: 4px;
  }
}
.buttons {
  border-bottom: 1px solid #d4d6dd;
  padding: 0px 0px 32px 0px;
}
.button_transparent {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: transparent;
  color: $primary;
  border: 2px solid $primary;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 16px;
}
.button {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $black;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}
.img {
  margin-right: 8px;
  width: 12px;
  height: 12px;
}
.connection {
  margin: 0 auto;
  margin-bottom: 16px;
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 1px;
  color: #f7f7f7;
}
.contacts {
  display: grid;
  grid-template-columns: 4fr 1fr 1fr;
  max-width: 300px;
  grid-gap: 10px;
  margin: 0 auto;
}

.contact {
  margin-right: 12px;
  padding: 0px 0px;
  text-align: center;
  background-color: transparent;
  border: none;
  margin-bottom: 50px;
  img {
    width: 100%;
  }
  &:last-child {
    margin-right: 0px;
  }
}
.contact_button {
  font-weight: 400;
  font-size: 12px;
  background-color: #27d045;
  border-radius: 50px;
  color: $white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px 0 0;
  outline: none;
  border: none;
  align-self: flex-start;
  text-wrap: nowrap;
  margin: 0 6px;
}
.buttonCopied {
  text-align: center;
  background-color: $primary;
  color: $black;
  border: 2px solid $primary;
  transition: all 0.2s ease-in-out;
  img {
    filter: brightness(0) !important;
  }
}

.deleteIndent {
  .photo {
    margin: 0;
  }
}
</style>

<style lang="scss">
.swiper {
  height: 345px;
}
.custom-pagination {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}
.pagination-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.6);
  margin: 0 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.pagination-dot.active {
  background-color: $primary;
}
</style>
